import {
  HttpSurveyTargetLine,
  ISurveyTargetLineParser,
} from "../surveyRepository.types";
import { err, ok, Result } from "neverthrow";
import { ISurveyTargetLine, SurveyTargetLine } from "@/domain/entities/survey/index";
import { ParseError } from "@/repositories/shared/errors/parseError";
import { injectable } from "inversify";

@injectable()
export class SurveyTargetLineParser implements ISurveyTargetLineParser {
  constructor() {}

  toDomain(data: HttpSurveyTargetLine): Result<ISurveyTargetLine, ParseError> {
    try {
      const targetLine: ISurveyTargetLine = {
        lineTurnUid: data.lineTurnUid,
        lineTurnName: data.lineTurnName,
        turnFullName: `${data.lineTurnName}(${data.lineTypeName})`,
        lineTypeCode: data.lineTypeCode,
        lineTypeName: data.lineTypeName,
      };
      const survey = new SurveyTargetLine(targetLine);
      return ok(survey);
    } catch (error: any) {
      return err(new ParseError(error.message));
    }
  }
}
